import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

export namespace OnlyFansEarningsStatsReferralsBalance {
    export interface Response {
        referralEarnings: number;
    }
}

const useSubscriberReferralsBalance = (subscriberId: string | undefined) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const axios = useAxios();

    const fetchData = async (): Promise<OnlyFansEarningsStatsReferralsBalance.Response | null> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !subscriberId) {
            return null;
        }

        const query = `${settingsContext.routes.onlyFans.base}${subscriberId}/referrals/balance`;

        return axios
            .get(query)
            .then(response => response.data as OnlyFansEarningsStatsReferralsBalance.Response)
            .catch(error => {
                handleHttpError(error, dialog);

                return null;
            });
    };

    return useQuery(['subscriberReferralsBalance', subscriberId], fetchData, {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 5, // 5 minutes
        enabled: !!(userContext.jwtToken && settingsContext.apiKey && subscriberId),
    });
};

export default useSubscriberReferralsBalance;
